exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-d5df5a48] .el-divider__text{font-weight:700;font-size:16px}[data-v-d5df5a48] .el-card__body{height:100%;padding-bottom:0!important}[data-v-d5df5a48] .custom-height{height:calc(100% - 40px)}.custom-title[data-v-d5df5a48]{color:var(--textColor)}", ""]);

// exports
